import React from "react";

const Summary = ({
  formMasterList,
  handleChangeMaster,
  handleBlurMaster,
  handleFocusMaster,
  selectedDiscountValueType,
  handleCheckboxChange,
  receiptDiscount,
  formatCurrency,
  parseCurrency,
  totalPrice,
  subFinal,
  isVatChecked,
  handleVatChange,
  vatAmount,
  grandTotal,
  disabled,
}) => {
  return (
    <div className="col-12" style={{ justifyItems: "flex-end" }}>
      <div
        className="card"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <div className="card-body" style={{ padding: "0.2rem" }}>
          <div className="row">
            <div className="" style={{ width: "335px" }}>
              <div hidden={false}>
                <h4 className="card-title" style={{ textAlign: "center" }}>
                  ยอดท้ายบิล
                </h4>
                <div className="row mt-3">
                  <div className="col-12">
                    <div className="d-flex align-items-center mt-1">
                      <label>รวมราคา</label>
                      <input
                        type="text"
                        className="form-control text-end input-spacing"
                        style={{ width: "100px" }}
                        value={formatCurrency(totalPrice || 0)}
                        disabled={true}
                      />
                    </div>
                    <div className="d-flex align-items-center mt-1">
                      <label>ส่วนลด</label>
                      <div className="col-3">
                        <div className="row">
                          <div className="radio-inline">
                            {window.location.pathname === "/billofsale" && (
                              <>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="1"
                                  checked={selectedDiscountValueType === "1"}
                                  onChange={handleCheckboxChange}
                                  // disabled={true}
                                  // o
                                />
                                <label className="form-check-label">฿</label>
                              </>
                            )}
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="2"
                              checked={selectedDiscountValueType === "2"}
                              onChange={handleCheckboxChange}
                              // disabled={true}
                            />
                            <label className="form-check-label">%</label>
                          </div>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control text-end input-spacing"
                        style={{ width: "100px" }}
                        name="discountValue"
                        // value={
                        //   disabled
                        //     ? formatCurrency(formMasterList.discountValue || 0)
                        //     : formatCurrency(
                        //         parseCurrency(formMasterList.discountValue || 0)
                        //       )
                        // }
                        value={formMasterList.discountValue || ""}
                        onChange={handleChangeMaster}
                        onBlur={handleBlurMaster}
                        onFocus={handleFocusMaster}
                      />
                    </div>
                    <hr />
                    <div className="d-flex align-items-center mt-1">
                      <label>ราคาหลังหักส่วนลด</label>
                      <input
                        type="text"
                        className="form-control text-end input-spacing"
                        style={{ width: "100px" }}
                        value={formatCurrency(subFinal || 0)}
                        disabled={true}
                      />
                    </div>
                    <div className="d-flex align-items-center mt-1">
                      {window.location.pathname !== "/bill" && (
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={isVatChecked}
                          onChange={handleVatChange}
                          disabled={disabled}
                          style={{ width: "20px" }}
                        />
                      )}
                      <label className="mr-3">VAT (7%)</label>
                      <input
                        type="text"
                        className="form-control text-end input-spacing"
                        style={{ width: "100px" }}
                        value={formatCurrency(vatAmount || 0)}
                        disabled={true}
                      />
                    </div>
                    <hr />
                    <div className="d-flex align-items-center mt-1">
                      <label>
                        <h5>รวมทั้งสิ้น</h5>
                      </label>
                      <input
                        type="text"
                        className="form-control text-end input-spacing"
                        style={{
                          width: "100px",
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                        value={formatCurrency(grandTotal || 0)}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
